import { NEGATIVE_INDICES_COLOR, POSITIVE_INDICES_COLOR } from 'IndicesApp/ts/apps/index-family-app/constants';
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import { IndicesService } from 'IndicesApp/ts/shared/services/indices.service';
import { formatChange } from 'Angular/utils/string-utils';
import * as i0 from "@angular/core";
import * as i1 from "AccountsApp/ts/services/accounts.service";
import * as i2 from "IndicesApp/ts/shared/services/indices.service";
import * as i3 from "@angular/common";
import * as i4 from "../../../../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
const _c0 = a0 => ({ "current": a0 });
const _c1 = () => [];
function IndicesPageGainersLosersComponent_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 7)(1, "a", 8);
    i0.ɵɵlistener("click", function IndicesPageGainersLosersComponent_li_1_Template_a_click_1_listener() { const periodicityOption_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.updatePeriodicity(periodicityOption_r2.value)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const periodicityOption_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0, periodicityOption_r2.value === ctx_r2.periodicity));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", periodicityOption_r2.label, " ");
} }
function IndicesPageGainersLosersComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵelement(1, "ycn-loading-symbol", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("loaderMessage", "Loading Top Gainers and Losers...");
} }
function IndicesPageGainersLosersComponent_div_4_div_4_ng_container_2_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 19)(1, "div", 20)(2, "span", 21);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 22)(5, "div", 23);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 24)(8, "span");
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(10, "span");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const i_r4 = i0.ɵɵnextContext().index;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(i0.ɵɵinterpolate1("stock ", ctx_r2.gainers[i_r4].color, " col-3"));
    i0.ɵɵproperty("href", i0.ɵɵinterpolate(ctx_r2.gainers[i_r4].url), i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r2.gainers[i_r4].security_id);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r2.gainers[i_r4].security_name);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("\u00A0", ctx_r2.gainers[i_r4].change_percent, "% ");
} }
function IndicesPageGainersLosersComponent_div_4_div_4_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, IndicesPageGainersLosersComponent_div_4_div_4_ng_container_2_a_1_Template, 11, 8, "a", 18);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r4 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext(3);
    const emptyCell_r5 = i0.ɵɵreference(7);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.gainers[i_r4])("ngIfElse", emptyCell_r5);
} }
function IndicesPageGainersLosersComponent_div_4_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15)(1, "div", 16);
    i0.ɵɵtemplate(2, IndicesPageGainersLosersComponent_div_4_div_4_ng_container_2_Template, 2, 2, "ng-container", 17);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpureFunction0(1, _c1).constructor(8));
} }
function IndicesPageGainersLosersComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "div", 12)(2, "div", 13);
    i0.ɵɵtext(3, "Top Gainers");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(4, IndicesPageGainersLosersComponent_div_4_div_4_Template, 3, 2, "div", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const noData_r6 = i0.ɵɵreference(9);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r2.gainersNoData)("ngIfElse", noData_r6);
} }
function IndicesPageGainersLosersComponent_div_5_div_4_ng_container_2_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 19)(1, "div", 20)(2, "span", 21);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 22)(5, "div", 23);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 24)(8, "span");
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(10, "span");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const i_r7 = i0.ɵɵnextContext().index;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(i0.ɵɵinterpolate1("stock ", ctx_r2.losers[i_r7].color, " col-3"));
    i0.ɵɵproperty("href", i0.ɵɵinterpolate(ctx_r2.losers[i_r7].url), i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r2.losers[i_r7].security_id);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r2.losers[i_r7].security_name);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("\u00A0", ctx_r2.losers[i_r7].change_percent, "% ");
} }
function IndicesPageGainersLosersComponent_div_5_div_4_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, IndicesPageGainersLosersComponent_div_5_div_4_ng_container_2_a_1_Template, 11, 8, "a", 18);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r7 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext(3);
    const emptyCell_r5 = i0.ɵɵreference(7);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.losers[i_r7])("ngIfElse", emptyCell_r5);
} }
function IndicesPageGainersLosersComponent_div_5_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15)(1, "div", 16);
    i0.ɵɵtemplate(2, IndicesPageGainersLosersComponent_div_5_div_4_ng_container_2_Template, 2, 2, "ng-container", 17);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpureFunction0(1, _c1).constructor(8));
} }
function IndicesPageGainersLosersComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "div", 12)(2, "div", 13);
    i0.ɵɵtext(3, "Top Losers");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(4, IndicesPageGainersLosersComponent_div_5_div_4_Template, 3, 2, "div", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const noData_r6 = i0.ɵɵreference(9);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r2.losersNoData)("ngIfElse", noData_r6);
} }
function IndicesPageGainersLosersComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25)(1, "div", 20)(2, "span", 21);
    i0.ɵɵtext(3, "\u00A0");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 22)(5, "div", 24)(6, "span");
    i0.ɵɵtext(7, "\u00A0");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "span");
    i0.ɵɵtext(9, "\u00A0");
    i0.ɵɵelementEnd()()()();
} }
function IndicesPageGainersLosersComponent_ng_template_8_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25)(1, "div", 20)(2, "span", 21);
    i0.ɵɵtext(3, "\u00A0");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 22)(5, "div", 24)(6, "span");
    i0.ɵɵtext(7, "\u00A0");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "span");
    i0.ɵɵtext(9, "\u00A0");
    i0.ɵɵelementEnd()()()();
} }
function IndicesPageGainersLosersComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15)(1, "div", 16);
    i0.ɵɵtemplate(2, IndicesPageGainersLosersComponent_ng_template_8_div_2_Template, 10, 0, "div", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 27);
    i0.ɵɵtext(4, "No Data Available");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpureFunction0(1, _c1).constructor(8));
} }
export class IndicesPageGainersLosersComponent {
    constructor(accountsService, indicesService) {
        this.accountsService = accountsService;
        this.indicesService = indicesService;
        this.gainers = [];
        this.losers = [];
        this.gainerColors = POSITIVE_INDICES_COLOR;
        this.loserColors = NEGATIVE_INDICES_COLOR;
        this.gainersNoData = true;
        this.losersNoData = true;
        this.loading = true;
        this.periodicity = null;
        this.PERIODICITY_OPTIONS = [
            { label: '1d', value: '1d' },
            { label: '5d', value: '5d' },
            { label: '1m', value: '1m' },
            { label: '3m', value: '3m' },
            { label: '6m', value: '6m' },
            { label: 'YTD', value: 'ytd' },
            { label: '1y', value: '1y' },
            { label: '5y', value: '5y' },
            { label: '10y', value: '10y' },
            { label: 'MAX', value: 'max' },
        ];
    }
    ngOnInit() {
        this.accountsService.getUserPreferences().subscribe({
            next: (preference) => {
                this.periodicity = preference.indices_page_performance_by_family_periodicity;
                this.getGainersLosers(this.currFamilyName, this.periodicity);
            },
            error: () => {
                this.periodicity = '1y'; // if we don't have a saved preference for periodicity
                this.getGainersLosers(this.currFamilyName, this.periodicity);
            },
        });
    }
    formatChanges(indices) {
        /**
         * reformats each index changes so positive and 0 values have leading '+'.
         */
        const gainersLosersWithReformattedChanges = [];
        for (let i = 0; i < indices.length; i += 1) {
            const index = Object.assign(indices[i]);
            index.change_percent = formatChange(index.change_percent);
            gainersLosersWithReformattedChanges.push(index);
        }
        return gainersLosersWithReformattedChanges;
    }
    getGainersLosersColorGradient(indices, isGainer) {
        /**
         * Assigns the color gradient to each index. If the `change_percent` is the same as the previous
         * index, the same color is used.
         */
        const colors = isGainer ? this.gainerColors : this.loserColors;
        let colorIndex = 0;
        const gainersLosersWithColorGradient = [];
        for (let i = 0; i < indices.length; i += 1) {
            // Create the color attribute for each index
            const index = Object.assign(indices[i], { color: '' });
            if (indices[i - 1] && indices[i].change_percent === indices[i - 1].change_percent) {
                index.color = gainersLosersWithColorGradient[i - 1].color;
            }
            else {
                index.color = colors[colorIndex] ? colors[colorIndex] : 'bg-neutral';
                colorIndex += 1;
            }
            gainersLosersWithColorGradient.push(index);
        }
        return gainersLosersWithColorGradient;
    }
    getGainersLosers(indexFamily, periodicity) {
        this.currFamilyName = indexFamily;
        this.periodicity = periodicity;
        this.loading = true;
        this.indicesService.getIndicesPageGainersLosers(this.currFamilyName, this.periodicity).subscribe({
            next: (response) => {
                this.gainersNoData = response.gainers.length === 0;
                this.losersNoData = response.losers.length === 0;
                this.gainers = this.formatChanges(this.getGainersLosersColorGradient(response.gainers, true));
                this.losers = this.formatChanges(this.getGainersLosersColorGradient(response.losers, false));
                this.loading = false;
            },
            error: () => {
                this.gainersNoData = true;
                this.losersNoData = true;
                this.loading = false;
            },
        });
    }
    updatePeriodicity(periodicityOptionValue) {
        this.getGainersLosers(this.currFamilyName, periodicityOptionValue);
    }
}
IndicesPageGainersLosersComponent.ɵfac = function IndicesPageGainersLosersComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || IndicesPageGainersLosersComponent)(i0.ɵɵdirectiveInject(i1.AccountsService), i0.ɵɵdirectiveInject(i2.IndicesService)); };
IndicesPageGainersLosersComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: IndicesPageGainersLosersComponent, selectors: [["ycn-indices-page-gainers-losers"]], inputs: { currFamilyName: "currFamilyName" }, standalone: false, decls: 10, vars: 4, consts: [["emptyCell", ""], ["noData", ""], [1, "chart-control", "chart-control-compact"], ["class", "chart-control-item", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "divider-horizontal"], ["class", "stocks d-flex justify-content-center align-items-center", "style", "height: 360px;", 4, "ngIf"], ["class", "stocks", 4, "ngIf"], [1, "chart-control-item", 3, "ngClass"], ["href", "javascript:void(0)", 1, "chart-control-link", 3, "click"], [1, "stocks", "d-flex", "justify-content-center", "align-items-center", 2, "height", "360px"], [3, "loaderMessage"], [1, "stocks"], [1, "stocks-header"], [1, "stocks-title"], ["class", "stocks-body", 4, "ngIf", "ngIfElse"], [1, "stocks-body"], [1, "row", "no-gutters"], [4, "ngFor", "ngForOf"], ["target", "_blank", 3, "class", "href", 4, "ngIf", "ngIfElse"], ["target", "_blank", 3, "href"], [1, "stock-header"], [1, "stock-title"], [1, "stock-content"], [1, "stock-descr"], [1, "stock-value"], [1, "stock", "bg-neutral", "col-3"], ["class", "stock bg-neutral col-3", 4, "ngFor", "ngForOf"], [1, "panel-data-empty-message"]], template: function IndicesPageGainersLosersComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ul", 2);
        i0.ɵɵtemplate(1, IndicesPageGainersLosersComponent_li_1_Template, 3, 4, "li", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(2, "div", 4);
        i0.ɵɵtemplate(3, IndicesPageGainersLosersComponent_div_3_Template, 2, 1, "div", 5)(4, IndicesPageGainersLosersComponent_div_4_Template, 5, 2, "div", 6)(5, IndicesPageGainersLosersComponent_div_5_Template, 5, 2, "div", 6)(6, IndicesPageGainersLosersComponent_ng_template_6_Template, 10, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(8, IndicesPageGainersLosersComponent_ng_template_8_Template, 5, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx.PERIODICITY_OPTIONS);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.loading);
    } }, dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf, i4.LoadingSymbolComponent], encapsulation: 2 });
